import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const ServicesPage = () => {
  const services = [
    {
      title: "Web Development",
      desc: "Modern responsive websites for business growth.",
      img: "https://images.pexels.com/photos/574071/pexels-photo-574071.jpeg",
    },
    {
      title: "App Development",
      desc: "Android & iOS apps with smooth performance.",
      img: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
    },
    {
      title: "Digital Marketing",
      desc: "Grow your brand with smart marketing strategies.",
      img: "https://images.pexels.com/photos/905163/pexels-photo-905163.jpeg",
    },
    {
      title: "UI/UX Design",
      desc: "Clean and modern user interface design.",
      img: "https://images.pexels.com/photos/196644/pexels-photo-196644.jpeg",
    },
    {
      title: "E-Commerce",
      desc: "Complete online store with payment integration.",
      img: "https://images.pexels.com/photos/230544/pexels-photo-230544.jpeg",
    },
    {
      title: "SEO Optimization",
      desc: "Rank higher on Google and increase traffic.",
      img: "https://images.pexels.com/photos/270348/pexels-photo-270348.jpeg",
    },
  ];

  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-white overflow-hidden">

      <section className="relative h-[75vh] flex items-center justify-center text-center">

        <img
          src="https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg"
          className="absolute inset-0 w-full h-full object-cover"
          alt="hero"
        />

        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative z-10 max-w-3xl px-6 text-white">
          <p className="uppercase tracking-[5px] text-sm text-white/70">
            Our Professional Services
          </p>

          <h1 className="mt-5 text-4xl md:text-5xl font-bold leading-tight">
            We Build Digital Products That Scale Your Business
          </h1>

          <p className="mt-5 text-white/70 text-sm md:text-base">
            Web development, apps, design & marketing solutions tailored for modern businesses.
          </p>

          <div className="mt-8 flex gap-4 justify-center flex-wrap">

            <Link
              to="/contact"
              className="px-8 py-3 bg-red-600 hover:bg-red-700 rounded-full font-semibold transition"
            >
              Get Started
            </Link>

            <Link
              to="/about"
              className="px-8 py-3 border border-white/40 hover:bg-white hover:text-black rounded-full font-semibold transition"
            >
              Learn More
            </Link>

          </div>
        </div>
      </section>

      <section
        ref={ref}
        className="max-w-7xl mx-auto px-6 py-24 grid sm:grid-cols-2 lg:grid-cols-3 gap-10"
      >
        {services.map((item, i) => (
          <div
            key={i}
            className={`relative group h-[320px] rounded-3xl overflow-hidden shadow-md transition-all duration-700 transform-gpu
            ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}
            hover:-translate-y-2 hover:shadow-2xl`}
            style={{ transitionDelay: `${i * 120}ms` }}
          >

            <img
              src={item.img}
              alt={item.title}
              className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-110 transition duration-700 will-change-transform"
            />

            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-black/30"></div>


            <div className="absolute inset-0 flex items-end p-6 text-white">

              <div className="p-5 w-full rounded-2xl bg-white/10 backdrop-blur-md border border-white/10">

                <h3 className="text-xl font-bold">{item.title}</h3>

                <p className="text-sm text-gray-200 mt-2">
                  {item.desc}
                </p>

                <Link
                  to={`/service/${item.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="mt-4 inline-block text-sm text-red-300 hover:text-red-400 font-semibold"
                >
                  Explore More →
                </Link>

              </div>

            </div>
          </div>
        ))}
      </section>

      <section className="py-24 text-center">
        <h2 className="text-3xl font-bold text-gray-900">
          Let’s Build Something Powerful Together
        </h2>

        <p className="text-gray-500 mt-3">
          Start your digital journey with us today.
        </p>

        <Link
          to="/contact"
          className="inline-block mt-6 px-10 py-3 bg-red-600 text-white rounded-full font-semibold hover:bg-red-700 transition hover:scale-105"
        >
          Get Started
        </Link>
      </section>

    </div>
  );
};

export default ServicesPage;